const prefix = 'img';

const files = {
  byId: {
    // arrow: {
    //     width: 24,
    //     height: 42,
    //     viewBox: [0, 0, 24, 42],
    //     data: '<path xmlns="http://www.w3.org/2000/svg" fill="none" d="M0 0H24V42H0z"/><path xmlns="http://www.w3.org/2000/svg" fill="#a2a2a2" d="M21.483,22.116,6.736,37.3a3.867,3.867,0,0,1-5.581,0,4.148,4.148,0,0,1,0-5.745l9.081-12.308L1.156,6.936a4.148,4.148,0,0,1,0-5.745,3.864,3.864,0,0,1,5.581,0L21.483,16.369a4.15,4.15,0,0,1,0,5.747Z" transform="translate(1.361 1.758)"/>',
    // },
    // back: {
    //     width: 48,
    //     height: 48,
    //     viewBox: [0, 0, 48, 48],
    //     data: '<path xmlns="http://www.w3.org/2000/svg" fill="none" d="M0 0H48V48H0z"/><path xmlns="http://www.w3.org/2000/svg" fill="none" d="M0,0H46V46H0Z" transform="translate(1 1)"/><path xmlns="http://www.w3.org/2000/svg" d="M34.667,17.417H11.341L22.055,6.7,19.333,4,4,19.333,19.333,34.667l2.7-2.7L11.341,21.25H34.667Z" transform="translate(4.667 4.667)"/>',
    // },
    arrowdownforward: {
      width: 24,
      height: 24,
      viewBox: [0, 0, 24, 24],
      data: '<g xmlns="http://www.w3.org/2000/svg" opacity=".6"><path fill="none" d="M0 0h24v24H0z" transform="rotate(90 12 12)"/><path d="M3.77 6.23 2 8l10 10L22 8l-1.77-1.77L12 14.46z"/></g>',
    },
    // "moble-icon": {
    //     width: 18,
    //     height: 18,
    //     viewBox: [0, 0, 18, 18],
    //     data: '<defs xmlns="http://www.w3.org/2000/svg"><clipPath id="a"><path fill="#fff" stroke="#707070" d="M0 0h18v18H0z" transform="translate(-6032 -6856)"/></clipPath></defs><g xmlns="http://www.w3.org/2000/svg" clip-path="url(#a)" opacity=".8" transform="translate(6032 6856)"><path d="M-6020.347-6853.927h-5.652a.978.978 0 0 0-.978.979v11.478a.977.977 0 0 0 .978.978h5.653a.978.978 0 0 0 .978-.978v-11.478a.978.978 0 0 0-.979-.979zm-4.221.594h2.791c.07 0 .128.105.128.235s-.057.236-.128.236h-2.791c-.071 0-.127-.106-.127-.236s.056-.235.127-.235zm1.4 11.875a.624.624 0 1 1 .623-.625.625.625 0 0 1-.628.625zm3.071-2.139h-6.147v-8.679h6.143v8.679z"/></g>',
    // },
  },
  allIds: ['arrowdownforward'],
};

function SVGCommon(props) {
  if (props.isHidden) {
    return <svg display="none">{props.children}</svg>;
  }

  let file = files.byId[props.id];

  if (!file) return null;

  let width = props.width || file.width || null;
  let height = props.height || file.height || null;
  let viewBox = file.viewBox
    ? file.viewBox.join(' ')
    : '0 0 ' + props.width + ' ' + props.height;

  return props.isHidden ? (
    <svg display="none">{props.children}</svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      preserveAspectRatio="xMinYMin"
      width={width}
      height={height}
      viewBox={viewBox}
      className={props.className}
    >
      <use xlinkHref={'#' + prefix + '-' + props.id} />
    </svg>
  );
}

function SVGSourceCommon(props) {
  return (
    <SVGCommon isHidden={true}>
      <defs>
        {files.allIds.reduce((defs, fileId, fileIndex) => {
          const file = files.byId[fileId];
          return defs.concat(
            <g
              key={fileIndex}
              id={prefix + '-' + fileId}
              dangerouslySetInnerHTML={{ __html: file.data }}
            ></g>,
          );
        }, [])}
      </defs>
    </SVGCommon>
  );
}

export { SVGCommon, SVGSourceCommon };
